module.exports = __webpack_public_path__ + "img/supply.4b2eda1d.jpg";